import { ICountry } from '@models/country.interface';

export const countries: ICountry[] = [
  {
    code: 'AF',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/af.png',
      description: 'Afghanistan'
    },
    name: 'Afghanistan'
  },
  {
    code: 'AX',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/ax.png',
      description: 'Aland Islands'
    },
    name: 'Aland Islands'
  },
  {
    code: 'AL',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/al.png',
      description: 'Albania'
    },
    name: 'Albania'
  },
  {
    code: 'DZ',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/dz.png',
      description: 'Algeria'
    },
    name: 'Algeria'
  },
  {
    code: 'AS',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/as.png',
      description: 'American Samoa'
    },
    name: 'American Samoa'
  },
  {
    code: 'AD',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/ad.png',
      description: 'Andorra'
    },
    name: 'Andorra'
  },
  {
    code: 'AO',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/ao.png',
      description: 'Angola'
    },
    name: 'Angola'
  },
  {
    code: 'AI',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/ai.png',
      description: 'Anguilla'
    },
    name: 'Anguilla'
  },
  {
    code: 'AG',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/ag.png',
      description: 'Antigua and Barbuda'
    },
    name: 'Antigua and Barbuda'
  },
  {
    code: 'AR',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/ar.png',
      description: 'Argentina'
    },
    name: 'Argentina'
  },
  {
    code: 'AM',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/am.png',
      description: 'Armenia'
    },
    name: 'Armenia'
  },
  {
    code: 'AW',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/aw.png',
      description: 'Aruba'
    },
    name: 'Aruba'
  },
  {
    code: 'AU',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/au.png',
      description: 'Australia'
    },
    name: 'Australia'
  },
  {
    code: 'AT',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/at.png',
      description: 'Austria'
    },
    name: 'Austria'
  },
  {
    code: 'AZ',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/az.png',
      description: 'Azerbaijan'
    },
    name: 'Azerbaijan'
  },
  {
    code: 'BS',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/bs.png',
      description: 'Bahamas'
    },
    name: 'Bahamas'
  },
  {
    code: 'BH',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/bh.png',
      description: 'Bahrain'
    },
    name: 'Bahrain'
  },
  {
    code: 'BD',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/bd.png',
      description: 'Bangladesh'
    },
    name: 'Bangladesh'
  },
  {
    code: 'BB',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/bb.png',
      description: 'Barbados'
    },
    name: 'Barbados'
  },
  {
    code: 'BY',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/by.png',
      description: 'Belarus'
    },
    name: 'Belarus'
  },
  {
    code: 'BE',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/be.png',
      description: 'Belgium'
    },
    name: 'Belgium'
  },
  {
    code: 'BZ',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/bz.png',
      description: 'Belize'
    },
    name: 'Belize'
  },
  {
    code: 'BJ',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/bj.png',
      description: 'Benin'
    },
    name: 'Benin'
  },
  {
    code: 'BM',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/bm.png',
      description: 'Bermuda'
    },
    name: 'Bermuda'
  },
  {
    code: 'BT',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/bt.png',
      description: 'Bhutan'
    },
    name: 'Bhutan'
  },
  {
    code: 'BO',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/bo.png',
      description: 'Bolivia (Plurinational State of)'
    },
    name: 'Bolivia (Plurinational State of)'
  },
  {
    code: 'BQ',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/bq.png',
      description: 'Bonaire, Sint Eustatius and Saba'
    },
    name: 'Bonaire, Sint Eustatius and Saba'
  },
  {
    code: 'BA',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/ba.png',
      description: 'Bosnia and Herzegovina'
    },
    name: 'Bosnia and Herzegovina'
  },
  {
    code: 'BW',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/bw.png',
      description: 'Botswana'
    },
    name: 'Botswana'
  },
  {
    code: 'BR',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/br.png',
      description: 'Brazil'
    },
    name: 'Brazil'
  },
  {
    code: 'IO',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/io.png',
      description: 'British Indian Ocean Territory'
    },
    name: 'British Indian Ocean Territory'
  },
  {
    code: 'BN',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/bn.png',
      description: 'Brunei Darussalam'
    },
    name: 'Brunei Darussalam'
  },
  {
    code: 'BG',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/bg.png',
      description: 'Bulgaria'
    },
    name: 'Bulgaria'
  },
  {
    code: 'BF',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/bf.png',
      description: 'Burkina Faso'
    },
    name: 'Burkina Faso'
  },
  {
    code: 'BI',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/bi.png',
      description: 'Burundi'
    },
    name: 'Burundi'
  },
  {
    code: 'CV',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/cv.png',
      description: 'Cabo Verde'
    },
    name: 'Cabo Verde'
  },
  {
    code: 'KH',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/kh.png',
      description: 'Cambodia'
    },
    name: 'Cambodia'
  },
  {
    code: 'CM',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/cm.png',
      description: 'Cameroon'
    },
    name: 'Cameroon'
  },
  {
    code: 'CA',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/ca.png',
      description: 'Canada'
    },
    name: 'Canada'
  },
  {
    code: 'KY',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/ky.png',
      description: 'Cayman Islands'
    },
    name: 'Cayman Islands'
  },
  {
    code: 'CF',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/cf.png',
      description: 'Central African Republic'
    },
    name: 'Central African Republic'
  },
  {
    code: 'TD',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/td.png',
      description: 'Chad'
    },
    name: 'Chad'
  },
  {
    code: 'CL',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/cl.png',
      description: 'Chile'
    },
    name: 'Chile'
  },
  {
    code: 'CN',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/cn.png',
      description: 'China'
    },
    name: 'China'
  },
  {
    code: 'CX',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/cx.png',
      description: 'Christmas Island'
    },
    name: 'Christmas Island'
  },
  {
    code: 'CC',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/cc.png',
      description: 'Cocos (Keeling) Islands'
    },
    name: 'Cocos (Keeling) Islands'
  },
  {
    code: 'CO',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/co.png',
      description: 'Colombia'
    },
    name: 'Colombia'
  },
  {
    code: 'KM',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/km.png',
      description: 'Comoros'
    },
    name: 'Comoros'
  },
  {
    code: 'CK',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/ck.png',
      description: 'Cook Islands'
    },
    name: 'Cook Islands'
  },
  {
    code: 'CR',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/cr.png',
      description: 'Costa Rica'
    },
    name: 'Costa Rica'
  },
  {
    code: 'HR',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/hr.png',
      description: 'Croatia'
    },
    name: 'Croatia'
  },
  {
    code: 'CU',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/cu.png',
      description: 'Cuba'
    },
    name: 'Cuba'
  },
  {
    code: 'CW',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/cw.png',
      description: 'Curaçao'
    },
    name: 'Curaçao'
  },
  {
    code: 'CY',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/cy.png',
      description: 'Cyprus'
    },
    name: 'Cyprus'
  },
  {
    code: 'CZ',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/cz.png',
      description: 'Czech Republic'
    },
    name: 'Czech Republic'
  },
  {
    code: 'CI',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/ci.png',
      description: 'Côte Ivoire'
    },
    name: 'Côte Ivoire'
  },
  {
    code: 'CD',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/cd.png',
      description: 'Democratic Republic of the Congo'
    },
    name: 'Democratic Republic of the Congo'
  },
  {
    code: 'DK',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/dk.png',
      description: 'Denmark'
    },
    name: 'Denmark'
  },
  {
    code: 'DJ',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/dj.png',
      description: 'Djibouti'
    },
    name: 'Djibouti'
  },
  {
    code: 'DM',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/dm.png',
      description: 'Dominica'
    },
    name: 'Dominica'
  },
  {
    code: 'DO',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/do.png',
      description: 'Dominican Republic'
    },
    name: 'Dominican Republic'
  },
  {
    code: 'EC',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/ec.png',
      description: 'Ecuador'
    },
    name: 'Ecuador'
  },
  {
    code: 'EG',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/eg.png',
      description: 'Egypt'
    },
    name: 'Egypt'
  },
  {
    code: 'SV',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/sv.png',
      description: 'El Salvador'
    },
    name: 'El Salvador'
  },
  {
    code: 'GB-ENG',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/gb.png',
      description: 'England'
    },
    name: 'England'
  },
  {
    code: 'GQ',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/gq.png',
      description: 'Equatorial Guinea'
    },
    name: 'Equatorial Guinea'
  },
  {
    code: 'ER',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/er.png',
      description: 'Eritrea'
    },
    name: 'Eritrea'
  },
  {
    code: 'EE',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/ee.png',
      description: 'Estonia'
    },
    name: 'Estonia'
  },
  {
    code: 'ET',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/et.png',
      description: 'Ethiopia'
    },
    name: 'Ethiopia'
  },
  {
    code: 'FK',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/fk.png',
      description: 'Falkland Islands'
    },
    name: 'Falkland Islands'
  },
  {
    code: 'FO',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/fo.png',
      description: 'Faroe Islands'
    },
    name: 'Faroe Islands'
  },
  {
    code: 'FM',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/fm.png',
      description: 'Federated States of Micronesia'
    },
    name: 'Federated States of Micronesia'
  },
  {
    code: 'FJ',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/fj.png',
      description: 'Fiji'
    },
    name: 'Fiji'
  },
  {
    code: 'FI',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/fi.png',
      description: 'Finland'
    },
    name: 'Finland'
  },
  {
    code: 'FR',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/fr.png',
      description: 'France'
    },
    name: 'France'
  },
  {
    code: 'GF',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/gf.png',
      description: 'French Guiana'
    },
    name: 'French Guiana'
  },
  {
    code: 'PF',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/pf.png',
      description: 'French Polynesia'
    },
    name: 'French Polynesia'
  },
  {
    code: 'TF',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/tf.png',
      description: 'French Southern Territories'
    },
    name: 'French Southern Territories'
  },
  {
    code: 'GA',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/ga.png',
      description: 'Gabon'
    },
    name: 'Gabon'
  },
  {
    code: 'GM',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/gm.png',
      description: 'Gambia'
    },
    name: 'Gambia'
  },
  {
    code: 'GE',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/ge.png',
      description: 'Georgia'
    },
    name: 'Georgia'
  },
  {
    code: 'DE',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/de.png',
      description: 'Germany'
    },
    name: 'Germany'
  },
  {
    code: 'GH',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/gh.png',
      description: 'Ghana'
    },
    name: 'Ghana'
  },
  {
    code: 'GI',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/gi.png',
      description: 'Gibraltar'
    },
    name: 'Gibraltar'
  },
  {
    code: 'GR',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/gr.png',
      description: 'Greece'
    },
    name: 'Greece'
  },
  {
    code: 'GL',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/gl.png',
      description: 'Greenland'
    },
    name: 'Greenland'
  },
  {
    code: 'GD',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/gd.png',
      description: 'Grenada'
    },
    name: 'Grenada'
  },
  {
    code: 'GP',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/gp.png',
      description: 'Guadeloupe'
    },
    name: 'Guadeloupe'
  },
  {
    code: 'GU',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/gu.png',
      description: 'Guam'
    },
    name: 'Guam'
  },
  {
    code: 'GT',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/gt.png',
      description: 'Guatemala'
    },
    name: 'Guatemala'
  },
  {
    code: 'GG',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/gg.png',
      description: 'Guernsey'
    },
    name: 'Guernsey'
  },
  {
    code: 'GN',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/gn.png',
      description: 'Guinea'
    },
    name: 'Guinea'
  },
  {
    code: 'GW',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/gw.png',
      description: 'Guinea-Bissau'
    },
    name: 'Guinea-Bissau'
  },
  {
    code: 'GY',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/gy.png',
      description: 'Guyana'
    },
    name: 'Guyana'
  },
  {
    code: 'HT',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/ht.png',
      description: 'Haiti'
    },
    name: 'Haiti'
  },
  {
    code: 'VA',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/va.png',
      description: 'Holy See'
    },
    name: 'Holy See'
  },
  {
    code: 'HN',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/hn.png',
      description: 'Honduras'
    },
    name: 'Honduras'
  },
  {
    code: 'HK',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/hk.png',
      description: 'Hong Kong'
    },
    name: 'Hong Kong'
  },
  {
    code: 'HU',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/hu.png',
      description: 'Hungary'
    },
    name: 'Hungary'
  },
  {
    code: 'IS',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/is.png',
      description: 'Iceland'
    },
    name: 'Iceland'
  },
  {
    code: 'IN',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/in.png',
      description: 'India'
    },
    name: 'India'
  },
  {
    code: 'ID',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/id.png',
      description: 'Indonesia'
    },
    name: 'Indonesia'
  },
  {
    code: 'IR',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/ir.png',
      description: 'Iran (Islamic Republic of)'
    },
    name: 'Iran (Islamic Republic of)'
  },
  {
    code: 'IQ',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/iq.png',
      description: 'Iraq'
    },
    name: 'Iraq'
  },
  {
    code: 'IE',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/ie.png',
      description: 'Ireland'
    },
    name: 'Ireland'
  },
  {
    code: 'IM',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/im.png',
      description: 'Isle of Man'
    },
    name: 'Isle of Man'
  },
  {
    code: 'IL',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/il.png',
      description: 'Israel'
    },
    name: 'Israel'
  },
  {
    code: 'IT',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/it.png',
      description: 'Italy'
    },
    name: 'Italy'
  },
  {
    code: 'JM',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/jm.png',
      description: 'Jamaica'
    },
    name: 'Jamaica'
  },
  {
    code: 'JP',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/jp.png',
      description: 'Japan'
    },
    name: 'Japan'
  },
  {
    code: 'JE',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/je.png',
      description: 'Jersey'
    },
    name: 'Jersey'
  },
  {
    code: 'JO',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/jo.png',
      description: 'Jordan'
    },
    name: 'Jordan'
  },
  {
    code: 'KZ',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/kz.png',
      description: 'Kazakhstan'
    },
    name: 'Kazakhstan'
  },
  {
    code: 'KE',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/ke.png',
      description: 'Kenya'
    },
    name: 'Kenya'
  },
  {
    code: 'KI',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/ki.png',
      description: 'Kiribati'
    },
    name: 'Kiribati'
  },
  {
    code: 'KW',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/kw.png',
      description: 'Kuwait'
    },
    name: 'Kuwait'
  },
  {
    code: 'KG',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/kg.png',
      description: 'Kyrgyzstan'
    },
    name: 'Kyrgyzstan'
  },
  {
    code: 'LA',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/la.png',
      description: 'Laos'
    },
    name: 'Laos'
  },
  {
    code: 'LV',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/lv.png',
      description: 'Latvia'
    },
    name: 'Latvia'
  },
  {
    code: 'LB',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/lb.png',
      description: 'Lebanon'
    },
    name: 'Lebanon'
  },
  {
    code: 'LS',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/ls.png',
      description: 'Lesotho'
    },
    name: 'Lesotho'
  },
  {
    code: 'LR',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/lr.png',
      description: 'Liberia'
    },
    name: 'Liberia'
  },
  {
    code: 'LY',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/ly.png',
      description: 'Libya'
    },
    name: 'Libya'
  },
  {
    code: 'LI',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/li.png',
      description: 'Liechtenstein'
    },
    name: 'Liechtenstein'
  },
  {
    code: 'LT',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/lt.png',
      description: 'Lithuania'
    },
    name: 'Lithuania'
  },
  {
    code: 'LU',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/lu.png',
      description: 'Luxembourg'
    },
    name: 'Luxembourg'
  },
  {
    code: 'MO',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/mo.png',
      description: 'Macau'
    },
    name: 'Macau'
  },
  {
    code: 'MG',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/mg.png',
      description: 'Madagascar'
    },
    name: 'Madagascar'
  },
  {
    code: 'MW',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/mw.png',
      description: 'Malawi'
    },
    name: 'Malawi'
  },
  {
    code: 'MY',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/my.png',
      description: 'Malaysia'
    },
    name: 'Malaysia'
  },
  {
    code: 'MV',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/mv.png',
      description: 'Maldives'
    },
    name: 'Maldives'
  },
  {
    code: 'ML',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/ml.png',
      description: 'Mali'
    },
    name: 'Mali'
  },
  {
    code: 'MT',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/mt.png',
      description: 'Malta'
    },
    name: 'Malta'
  },
  {
    code: 'MH',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/mh.png',
      description: 'Marshall Islands'
    },
    name: 'Marshall Islands'
  },
  {
    code: 'MQ',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/mq.png',
      description: 'Martinique'
    },
    name: 'Martinique'
  },
  {
    code: 'MR',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/mr.png',
      description: 'Mauritania'
    },
    name: 'Mauritania'
  },
  {
    code: 'MU',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/mu.png',
      description: 'Mauritius'
    },
    name: 'Mauritius'
  },
  {
    code: 'YT',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/yt.png',
      description: 'Mayotte'
    },
    name: 'Mayotte'
  },
  {
    code: 'MX',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/mx.png',
      description: 'Mexico'
    },
    name: 'Mexico'
  },
  {
    code: 'MD',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/md.png',
      description: 'Moldova'
    },
    name: 'Moldova'
  },
  {
    code: 'MC',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/mc.png',
      description: 'Monaco'
    },
    name: 'Monaco'
  },
  {
    code: 'MN',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/mn.png',
      description: 'Mongolia'
    },
    name: 'Mongolia'
  },
  {
    code: 'ME',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/me.png',
      description: 'Montenegro'
    },
    name: 'Montenegro'
  },
  {
    code: 'MS',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/ms.png',
      description: 'Montserrat'
    },
    name: 'Montserrat'
  },
  {
    code: 'MA',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/ma.png',
      description: 'Morocco'
    },
    name: 'Morocco'
  },
  {
    code: 'MZ',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/mz.png',
      description: 'Mozambique'
    },
    name: 'Mozambique'
  },
  {
    code: 'MM',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/mm.png',
      description: 'Myanmar'
    },
    name: 'Myanmar'
  },
  {
    code: 'NA',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/na.png',
      description: 'Namibia'
    },
    name: 'Namibia'
  },
  {
    code: 'NR',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/nr.png',
      description: 'Nauru'
    },
    name: 'Nauru'
  },
  {
    code: 'NP',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/np.png',
      description: 'Nepal'
    },
    name: 'Nepal'
  },
  {
    code: 'NL',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/nl.png',
      description: 'Netherlands'
    },
    name: 'Netherlands'
  },
  {
    code: 'NC',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/nc.png',
      description: 'New Caledonia'
    },
    name: 'New Caledonia'
  },
  {
    code: 'NZ',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/nz.png',
      description: 'New Zealand'
    },
    name: 'New Zealand'
  },
  {
    code: 'NI',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/ni.png',
      description: 'Nicaragua'
    },
    name: 'Nicaragua'
  },
  {
    code: 'NE',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/ne.png',
      description: 'Niger'
    },
    name: 'Niger'
  },
  {
    code: 'NG',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/ng.png',
      description: 'Nigeria'
    },
    name: 'Nigeria'
  },
  {
    code: 'NU',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/nu.png',
      description: 'Niue'
    },
    name: 'Niue'
  },
  {
    code: 'NF',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/nf.png',
      description: 'Norfolk Island'
    },
    name: 'Norfolk Island'
  },
  {
    code: 'KP',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/kp.png',
      description: 'North Korea'
    },
    name: 'North Korea'
  },
  {
    code: 'MK',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/mk.png',
      description: 'North Macedonia'
    },
    name: 'North Macedonia'
  },
  {
    code: 'GB-NIR',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/gb.png',
      description: 'Northern Ireland'
    },
    name: 'Northern Ireland'
  },
  {
    code: 'MP',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/mp.png',
      description: 'Northern Mariana Islands'
    },
    name: 'Northern Mariana Islands'
  },
  {
    code: 'NO',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/no.png',
      description: 'Norway'
    },
    name: 'Norway'
  },
  {
    code: 'OM',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/om.png',
      description: 'Oman'
    },
    name: 'Oman'
  },
  {
    code: 'PK',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/pk.png',
      description: 'Pakistan'
    },
    name: 'Pakistan'
  },
  {
    code: 'PW',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/pw.png',
      description: 'Palau'
    },
    name: 'Palau'
  },
  {
    code: 'PA',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/pa.png',
      description: 'Panama'
    },
    name: 'Panama'
  },
  {
    code: 'PG',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/pg.png',
      description: 'Papua New Guinea'
    },
    name: 'Papua New Guinea'
  },
  {
    code: 'PY',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/py.png',
      description: 'Paraguay'
    },
    name: 'Paraguay'
  },
  {
    code: 'PE',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/pe.png',
      description: 'Peru'
    },
    name: 'Peru'
  },
  {
    code: 'PH',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/ph.png',
      description: 'Philippines'
    },
    name: 'Philippines'
  },
  {
    code: 'PN',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/pn.png',
      description: 'Pitcairn'
    },
    name: 'Pitcairn'
  },
  {
    code: 'PL',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/pl.png',
      description: 'Poland'
    },
    name: 'Poland'
  },
  {
    code: 'PT',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/pt.png',
      description: 'Portugal'
    },
    name: 'Portugal'
  },
  {
    code: 'PR',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/pr.png',
      description: 'Puerto Rico'
    },
    name: 'Puerto Rico'
  },
  {
    code: 'QA',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/qa.png',
      description: 'Qatar'
    },
    name: 'Qatar'
  },
  {
    code: 'CG',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/cg.png',
      description: 'Republic of the Congo'
    },
    name: 'Republic of the Congo'
  },
  {
    code: 'RO',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/ro.png',
      description: 'Romania'
    },
    name: 'Romania'
  },
  {
    code: 'RU',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/ru.png',
      description: 'Russia'
    },
    name: 'Russia'
  },
  {
    code: 'RW',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/rw.png',
      description: 'Rwanda'
    },
    name: 'Rwanda'
  },
  {
    code: 'RE',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/re.png',
      description: 'Réunion'
    },
    name: 'Réunion'
  },
  {
    code: 'BL',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/bl.png',
      description: 'Saint Barthélemy'
    },
    name: 'Saint Barthélemy'
  },
  {
    code: 'SH',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/sh.png',
      description: 'Saint Helena, Ascension and Tristan da Cunha'
    },
    name: 'Saint Helena, Ascension and Tristan da Cunha'
  },
  {
    code: 'KN',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/kn.png',
      description: 'Saint Kitts and Nevis'
    },
    name: 'Saint Kitts and Nevis'
  },
  {
    code: 'LC',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/lc.png',
      description: 'Saint Lucia'
    },
    name: 'Saint Lucia'
  },
  {
    code: 'MF',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/mf.png',
      description: 'Saint Martin'
    },
    name: 'Saint Martin'
  },
  {
    code: 'PM',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/pm.png',
      description: 'Saint Pierre and Miquelon'
    },
    name: 'Saint Pierre and Miquelon'
  },
  {
    code: 'VC',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/vc.png',
      description: 'Saint Vincent and the Grenadines'
    },
    name: 'Saint Vincent and the Grenadines'
  },
  {
    code: 'WS',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/ws.png',
      description: 'Samoa'
    },
    name: 'Samoa'
  },
  {
    code: 'SM',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/sm.png',
      description: 'San Marino'
    },
    name: 'San Marino'
  },
  {
    code: 'ST',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/st.png',
      description: 'Sao Tome and Principe'
    },
    name: 'Sao Tome and Principe'
  },
  {
    code: 'SA',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/sa.png',
      description: 'Saudi Arabia'
    },
    name: 'Saudi Arabia'
  },
  {
    code: 'GB-SCT',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/gb.png',
      description: 'Scotland'
    },
    name: 'Scotland'
  },
  {
    code: 'SN',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/sn.png',
      description: 'Senegal'
    },
    name: 'Senegal'
  },
  {
    code: 'RS',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/rs.png',
      description: 'Serbia'
    },
    name: 'Serbia'
  },
  {
    code: 'SC',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/sc.png',
      description: 'Seychelles'
    },
    name: 'Seychelles'
  },
  {
    code: 'SL',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/sl.png',
      description: 'Sierra Leone'
    },
    name: 'Sierra Leone'
  },
  {
    code: 'SG',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/sg.png',
      description: 'Singapore'
    },
    name: 'Singapore'
  },
  {
    code: 'SX',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/sx.png',
      description: 'Sint Maarten'
    },
    name: 'Sint Maarten'
  },
  {
    code: 'SK',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/sk.png',
      description: 'Slovakia'
    },
    name: 'Slovakia'
  },
  {
    code: 'SI',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/si.png',
      description: 'Slovenia'
    },
    name: 'Slovenia'
  },
  {
    code: 'SB',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/sb.png',
      description: 'Solomon Islands'
    },
    name: 'Solomon Islands'
  },
  {
    code: 'SO',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/so.png',
      description: 'Somalia'
    },
    name: 'Somalia'
  },
  {
    code: 'ZA',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/za.png',
      description: 'South Africa'
    },
    name: 'South Africa'
  },
  {
    code: 'GS',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/gs.png',
      description: 'South Georgia and the South Sandwich Islands'
    },
    name: 'South Georgia and the South Sandwich Islands'
  },
  {
    code: 'KR',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/kr.png',
      description: 'South Korea'
    },
    name: 'South Korea'
  },
  {
    code: 'SS',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/ss.png',
      description: 'South Sudan'
    },
    name: 'South Sudan'
  },
  {
    code: 'ES',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/es.png',
      description: 'Spain'
    },
    name: 'Spain'
  },
  {
    code: 'LK',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/lk.png',
      description: 'Sri Lanka'
    },
    name: 'Sri Lanka'
  },
  {
    code: 'PS',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/ps.png',
      description: 'State of Palestine'
    },
    name: 'State of Palestine'
  },
  {
    code: 'SD',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/sd.png',
      description: 'Sudan'
    },
    name: 'Sudan'
  },
  {
    code: 'SR',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/sr.png',
      description: 'Suriname'
    },
    name: 'Suriname'
  },
  {
    code: 'SJ',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/sj.png',
      description: 'Svalbard and Jan Mayen'
    },
    name: 'Svalbard and Jan Mayen'
  },
  {
    code: 'SZ',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/sz.png',
      description: 'Swaziland'
    },
    name: 'Swaziland'
  },
  {
    code: 'SE',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/se.png',
      description: 'Sweden'
    },
    name: 'Sweden'
  },
  {
    code: 'CH',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/ch.png',
      description: 'Switzerland'
    },
    name: 'Switzerland'
  },
  {
    code: 'SY',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/sy.png',
      description: 'Syrian Arab Republic'
    },
    name: 'Syrian Arab Republic'
  },
  {
    code: 'TW',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/tw.png',
      description: 'Taiwan'
    },
    name: 'Taiwan'
  },
  {
    code: 'TJ',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/tj.png',
      description: 'Tajikistan'
    },
    name: 'Tajikistan'
  },
  {
    code: 'TZ',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/tz.png',
      description: 'Tanzania'
    },
    name: 'Tanzania'
  },
  {
    code: 'TH',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/th.png',
      description: 'Thailand'
    },
    name: 'Thailand'
  },
  {
    code: 'TL',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/tl.png',
      description: 'Timor-Leste'
    },
    name: 'Timor-Leste'
  },
  {
    code: 'TG',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/tg.png',
      description: 'Togo'
    },
    name: 'Togo'
  },
  {
    code: 'TK',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/tk.png',
      description: 'Tokelau'
    },
    name: 'Tokelau'
  },
  {
    code: 'TO',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/to.png',
      description: 'Tonga'
    },
    name: 'Tonga'
  },
  {
    code: 'TT',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/tt.png',
      description: 'Trinidad and Tobago'
    },
    name: 'Trinidad and Tobago'
  },
  {
    code: 'TN',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/tn.png',
      description: 'Tunisia'
    },
    name: 'Tunisia'
  },
  {
    code: 'TR',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/tr.png',
      description: 'Turkey'
    },
    name: 'Turkey'
  },
  {
    code: 'TM',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/tm.png',
      description: 'Turkmenistan'
    },
    name: 'Turkmenistan'
  },
  {
    code: 'TC',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/tc.png',
      description: 'Turks and Caicos Islands'
    },
    name: 'Turks and Caicos Islands'
  },
  {
    code: 'TV',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/tv.png',
      description: 'Tuvalu'
    },
    name: 'Tuvalu'
  },
  {
    code: 'UG',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/ug.png',
      description: 'Uganda'
    },
    name: 'Uganda'
  },
  {
    code: 'UA',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/ua.png',
      description: 'Ukraine'
    },
    name: 'Ukraine'
  },
  {
    code: 'AE',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/ae.png',
      description: 'United Arab Emirates'
    },
    name: 'United Arab Emirates'
  },
  {
    code: 'GB',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/gb.png',
      description: 'United Kingdom'
    },
    name: 'United Kingdom'
  },
  {
    code: 'UM',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/um.png',
      description: 'United States Minor Outlying Islands'
    },
    name: 'United States Minor Outlying Islands'
  },
  {
    code: 'US',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/us.png',
      description: 'United States of America'
    },
    name: 'United States of America'
  },
  {
    code: 'UY',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/uy.png',
      description: 'Uruguay'
    },
    name: 'Uruguay'
  },
  {
    code: 'UZ',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/uz.png',
      description: 'Uzbekistan'
    },
    name: 'Uzbekistan'
  },
  {
    code: 'VU',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/vu.png',
      description: 'Vanuatu'
    },
    name: 'Vanuatu'
  },
  {
    code: 'VE',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/ve.png',
      description: 'Venezuela (Bolivarian Republic of)'
    },
    name: 'Venezuela (Bolivarian Republic of)'
  },
  {
    code: 'VN',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/vn.png',
      description: 'Vietnam'
    },
    name: 'Vietnam'
  },
  {
    code: 'VG',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/vg.png',
      description: 'Virgin Islands (British)'
    },
    name: 'Virgin Islands (British)'
  },
  {
    code: 'VI',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/vi.png',
      description: 'Virgin Islands (U.S.)'
    },
    name: 'Virgin Islands (U.S.)'
  },
  {
    code: 'GB-WLS',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/gb.png',
      description: 'Wales'
    },
    name: 'Wales'
  },
  {
    code: 'WF',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/wf.png',
      description: 'Wallis and Futuna'
    },
    name: 'Wallis and Futuna'
  },
  {
    code: 'EH',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/eh.png',
      description: 'Western Sahara'
    },
    name: 'Western Sahara'
  },
  {
    code: 'YE',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/ye.png',
      description: 'Yemen'
    },
    name: 'Yemen'
  },
  {
    code: 'ZM',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/zm.png',
      description: 'Zambia'
    },
    name: 'Zambia'
  },
  {
    code: 'ZW',
    options: {
      icon: 'assets/vendor/svg-country-flags/png100px/zw.png',
      description: 'Zimbabwe'
    },
    name: 'Zimbabwe'
  }
];
